import React from 'react'
import ClientReportsManagement from '../../admin/ClientReportsManagement'
import V3PageBridgeFrame from '../V3PageBridgeFrame'

export default function V3ClientReportsManagementPage() {
  return (
    <V3PageBridgeFrame>
      <ClientReportsManagement />
    </V3PageBridgeFrame>
  )
}
